import { render } from "./ResourceCardSmall.vue?vue&type=template&id=517b5ec4&scoped=true"
import script from "./ResourceCardSmall.vue?vue&type=script&lang=js"
export * from "./ResourceCardSmall.vue?vue&type=script&lang=js"

import "./ResourceCardSmall.vue?vue&type=style&index=0&id=517b5ec4&lang=sass&scoped=true"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-517b5ec4"]])

export default __exports__